export default function listService() {
  return function generate(viewField, engineApi) {
    viewField.metadata = viewField.metadata || {};
    viewField.metadata.max = viewField.metadata.max || viewField.max || 99999;

    const emptyLine = generateEmptyLine(viewField, engineApi);
    const element = engineApi.register
      .setCommonAttributes('fb-list', viewField, engineApi, { setDisabled: true })
      .addAttribute('parent', engineApi.utils.getParent(viewField.model))
      .addAttribute('empty-line-json', JSON.stringify(emptyLine), true, "'")
      .addAttribute('max', viewField.metadata.max) // @odeniel:  usar 'viewField.metadata.max' no 'viewField.max'
      .addAttribute('min', viewField.min || viewField.metadata.min || '0')
      .addAttribute('toolbar', JSON.stringify(viewField.metadata.toolbar), true, "'");

    element.append(engineApi.handleProperties(viewField, engineApi));

    return element;
  };

  function generateEmptyLine(viewField, engineApi) {
    return viewField.properties.reduce((acc, cur) => {
      const model = engineApi.utils.getLastItem(cur.model),
        initialValue = getDefaultValue(cur);
      if (initialValue) {
        acc[model] = initialValue;
      }
      return acc;
    }, {});
  }

  function getDefaultValue(viewField) {
    let defaultValue = '';
    if (viewField['default']) {
      defaultValue = `"${viewField['default']}"`;
    } else if (viewField.metadata && viewField.metadata.defaultExpression) {
      defaultValue = viewField.metadata.defaultExpression;
    }
    return defaultValue;
  }
}
